import React from "react";

import { SearchInput } from "@src/features/table_filtering/components/search_input";

interface ConfirmationHistoryTabToolBarProps {
  onQuickFilter: (quickSearch: string) => void;
  disabled: boolean;
}

const ConfirmationHistoryTabToolBar: React.FC<
  ConfirmationHistoryTabToolBarProps
> = ({ onQuickFilter, disabled }) => {
  return (
    <div className="tool-bar">
      <div className="tool-bar__button-section">
        <SearchInput
          onChange={onQuickFilter}
          disabled={disabled}
          title="data-confirmation"
        />
      </div>
    </div>
  );
};

export default ConfirmationHistoryTabToolBar;
